import React from 'react';
import { Box } from '@mui/material';

interface LogoProps {
  size?: 'small' | 'medium' | 'large';
  clickable?: boolean;
  onClick?: () => void;
}

const Logo: React.FC<LogoProps> = ({ size = 'medium', clickable = false, onClick }) => {
  const sizeMap = {
    small: 120,
    medium: 150,
    large: 200,
  };

  const width = sizeMap[size];

  const handleClick = () => {
    if (clickable && onClick) {
      onClick();
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        cursor: clickable ? 'pointer' : 'default',
        '&:hover': clickable
          ? {
              opacity: 0.8,
              transition: 'opacity 0.3s ease',
            }
          : {},
      }}
      onClick={handleClick}
    >
      <img
        src="/assets/alexa.svg"
        alt="Alexa Travel Agency"
        style={{
          width: `${width}px`,
          height: 'auto',
          maxWidth: '100%',
        }}
        onError={(e) => {
          // Fallback if image fails to load
          const target = e.target as HTMLImageElement;
          target.style.display = 'none';
          console.error('Logo failed to load');
        }}
      />
    </Box>
  );
};

export default Logo;
